import { FieldWrapperElement } from './FieldWrapper.styled';

interface FieldWrapperProps {
    children: React.ReactNode;
    className?: string;
}

export const FieldWrapper = ({ children, className }: FieldWrapperProps) => (
    <FieldWrapperElement className={className}>{children}</FieldWrapperElement>
);
